export const SocialData = [
    {
        platform: "Linkedin",
        link: "https://www.linkedin.com/in/animeshanand/",
        icon: require('../../assets/linkedin.svg').default
    },
    {
        platform: "Github",
        link: "https://github.com/animesh-anand-dev/",
        icon: require('../../assets/github.svg').default
    },
    {
        platform: "Facebook",
        link: "https://www.facebook.com/animeshanand.developer",
        icon: require('../../assets/facebook.svg').default
    },
    {
        platform: "Instagram",
        link: "https://instagram.com/animeshanand.developer",
        icon: require('../../assets/instagram.svg').default
    }
    
];